import OrbitApiV1 from '.'

class UenAPI {
  static companyNameSearch(query) {
    return OrbitApiV1.httpGet(`/uen/retrieveUen?companyName=${query}`)
  }

  static companyUENSearch(query) {
    return OrbitApiV1.httpGet(`/uen/retrieveUen?uen=${query}`)
  }

  static uenSearch(query) {
    return OrbitApiV1.httpGet(`/uen?uen=${query}`)
  }
}

export default UenAPI
